import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AttendanceDeviceService } from '../../../Model/AttendanceDevice/attendance-device.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { SessionService } from '../../../Util/Session/session.service';


@Component({
  selector: 'app-site-branch-mapping-form',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, NgSelectModule, NgbDropdownModule, RouterModule],
  templateUrl: './site-branch-mapping-form.component.html',
  styleUrl: './site-branch-mapping-form.component.scss'
})
export class SiteBranchMappingFormComponent {
  isDisabled: boolean = false;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  Devices = [] as any;

  FormData = {
    SelectType: 'i',
    ESS_SiteWiseDeviceDetailsID: 0,
    CodeType: 'Branch',
    BranchSiteCode: null,
    DeviceSerialNumber: null,
    Module: null,
    BranchID: null,
    ClientID: null,
    SiteID: null,
    CompanyCode: null,
  }

  constructor(
    protected common: CommonService,
    private combo: ComboService,
    private attendancedevice: AttendanceDeviceService,
    private router: Router,
    private toast: ToastService,
    private modalService: NgbModal,
    private tooltip: TooltipService,
    private route: ActivatedRoute,
    private session: SessionService,
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.FormData.ESS_SiteWiseDeviceDetailsID = parseInt(params['id']));

    this.FormData.CompanyCode = this.session.GetUserDetails().CompanyCode;
  }

  ngOnInit(): void {
    this.GetDeviceCompanyCode();
    if (this.FormData.ESS_SiteWiseDeviceDetailsID > 0) {
      this.ESS_SiteWiseDeviceDetailsSelect();
    } else {
      this.ComboChange();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.FormData.CodeType == 'Branch') {
        this.FormData.BranchSiteCode = this.Branchs.filter((e: any) => e.BranchMasterID == this.FormData.BranchID)[0].BranchCode;
      } else if (this.FormData.CodeType == 'Site') {
        this.FormData.BranchSiteCode = this.Sites.filter((e: any) => e.SiteMasterID == this.FormData.SiteID)[0].SiteCode;
      }
      this.ESS_SiteWiseDeviceDetails_InsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  ComboChange(isChecked = false) {
    if (this.Branchs.length == 0 && this.FormData.CodeType == 'Branch') {
      this.ComboLoad('Branch', isChecked);
    }
    this.ComboLoad('Client', isChecked);
    this.ComboLoad('Site', isChecked);
  }

  ComboLoad(Combotype: String, isChecked = false) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site') ? this.FormData.BranchID : 0,
      'ClientId': (Combotype == 'Client' || Combotype == 'Site') ? this.FormData.ClientID : 0
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          if (response.ComboLoad) {
            this.Branchs = response.ComboLoad;
            if (isChecked) {
              this.FormData.BranchID = this.Branchs.filter((e: any) => e.BranchCode == this.FormData.BranchSiteCode)[0].BranchMasterID;
            }
          }
        } else if (Combotype == 'Client') {
          if (response.ComboLoad) {
            this.Clients = response.ComboLoad;

            //if (this.FormData.BranchID != null && this.FormData.BranchID > 0) {
            this.FormData.ClientID = null;
            this.FormData.SiteID = null;
            //}
          }
        }
        else if (Combotype == 'Site') {
          if (response.ComboLoad) {
            this.Sites = response.ComboLoad;
            if (isChecked) {
              this.FormData.SiteID = this.Sites.filter((e: any) => e.SiteCode == this.FormData.BranchSiteCode)[0].SiteMasterID;
            }

            //if (this.FormData.ClientID != null && this.FormData.ClientID > 0) {
            this.FormData.SiteID = null;
            //}
          }
        }
        this.isDisabled = false
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_SiteWiseDeviceDetails_InsertUpdate() {
    //await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then((result) => {
      if ((this.FormData.ESS_SiteWiseDeviceDetailsID == 0 && this.common.PageRight.IsAdd) || (this.FormData.ESS_SiteWiseDeviceDetailsID > 0 && this.common.PageRight.IsEdit)) {
        if (result) {
          this.isDisabled = true;
          this.attendancedevice.ESS_SiteWiseDeviceDetails_InsertUpdate(this.FormData).subscribe({
            next: (response) => {
              if (response.Error_Code == '717') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Cancel()
                  }
                });
              }
              else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              console.log(response.Error_Message);
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  ESS_SiteWiseDeviceDetailsSelect() {
    this.isDisabled = true;
    this.attendancedevice.ESS_SiteWiseDeviceDetailsSelect({
      SelectType: 1,
      ESS_SiteWiseDeviceDetailsID: this.FormData.ESS_SiteWiseDeviceDetailsID,
    }).subscribe({
      next: (response) => {
        try {
          if (response.Table) {
            this.FormData.SelectType = 'u';
            this.FormData.ESS_SiteWiseDeviceDetailsID = response.Table[0].ESS_SiteWiseDeviceDetailsID;
            this.FormData.CodeType = response.Table[0].CodeType
            if (this.common.ToLowerCase(response.Table[0].CodeType) == 'branch') {
              this.FormData.BranchSiteCode = response.Table[0].BranchCode;
            } else if (this.common.ToLowerCase(response.Table[0].CodeType) == 'site') {
              this.FormData.BranchSiteCode = response.Table[0].SiteCode;
            }
            this.FormData.DeviceSerialNumber = response.Table[0].SerialNumber;
            this.FormData.Module = response.Table[0].Module;
            this.ComboChange(true);
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetDeviceCompanyCode() {
    this.isDisabled = true;
    this.attendancedevice.GetDeviceCompanyCode({
      CompanyCode: this.session.GetUserDetails().CompanyCode,
    }).subscribe({
      next: (response) => {
        try {
          this.Devices = response;
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Cancel() {
    this.router.navigate(['attendancedevice/sitebranchmapping']);
  }
}
